import { useState } from "react";
import { css } from "@emotion/react";

import Modal from "react-modal";

type Section = {
  title: string;
  id: string;
};

export const titles = [
  "NEWS",
  "TRAILER",
  "INTRODUCTION",
  "STORY",
  "CAST",
  "STAFF",
  "ORIGINAL",
  "THEATER",
];

export const titleToID = (title: string) => title.toLowerCase();

const sections: Section[] = [
  {
    title: "TOP",
    id: "top",
  },
  ...titles.map((title) => ({
    title,
    id: titleToID(title),
  })),
];

const modalStyleProp: Modal.Styles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(208, 1, 18, 0.8)",
    transition: "opacity 200ms ease-in-out",
  },
};

const HumburgerMenu: React.FC = ({}) => {
  const [isOpen, setIsOpen] = useState(false);

  /**
   * クリック時対象のセクションにスクロールする
   */
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };

  return (
    <>
      <div css={humburgerWrapperStyle(30, 20)}>
        {!isOpen ? (
          <img
            onClick={() => {
              setIsOpen(true);
            }}
            src={process.env.REACT_APP_ASSET_BASE_PATH + "/img/menu-btn.png"}
            alt="humburger-menu"
            css={humburgerImgStyle}
          />
        ) : (
          <img
            onClick={() => {
              setIsOpen(false);
            }}
            src={
              process.env.REACT_APP_ASSET_BASE_PATH + "/img/menu-close-btn.png"
            }
            alt="close"
            css={humburgerImgStyle}
          />
        )}
      </div>
      <Modal isOpen={isOpen} style={modalStyleProp} css={modalStyle}>
        <div css={menuContainerStyle}>
          <div css={menuTitleImgWrapperStyle}>
            <img
              src={
                process.env.REACT_APP_ASSET_BASE_PATH + "/img/menu-title.png"
              }
              css={menuTitleImgStyle}
            />
          </div>
          {sections.map((section) =>
            section.title === "THEATER" ? (
              <a
                key={section.id}
                css={menuItemStyle}
                href="https://theaters.jp/17964"
                target="_blank"
                rel="noopener"
              >
                {section.title}
              </a>
            ) : (
              <div
                key={section.id}
                onClick={() => {
                  scrollToSection(section.id);
                  setIsOpen(false);
                }}
                css={menuItemStyle}
              >
                {section.title}
              </div>
            ),
          )}
        </div>
      </Modal>
    </>
  );
};

const spSize = 768;

const humburgerWrapperStyle = (top?: number, topSP?: number) => css`
  position: absolute;
  top: ${top ?? 30}px;
  right: 40px;
  z-index: 1000;
  height: 65px;

  @media (max-width: ${spSize}px) {
    height: 30px;
    top: ${topSP ?? 20}px;
    right: 12px;
  }
`;

const humburgerImgStyle = css`
  height: 100%;
  width: auto;

  &:hover {
    cursor: pointer;
  }
`;

const modalStyle = css`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: url(${process.env.REACT_APP_ASSET_BASE_PATH +
  "/img/bg-menu.jpg"});
  background-size: cover;

  &:focus-visible {
    outline: none;
  }
`;

const menuTitleImgWrapperStyle = css`
  width: 100%;
  margin-bottom: 40px;
  display: flex;
  justify-content: center;

  @media (max-width: ${spSize}px) {
    margin-bottom: 40px;
  }
`;

const menuTitleImgStyle = css`
  width: 300px;
  height: auto;

  @media (max-width: ${spSize}px) {
    width: 45%;
  }
`;

const menuContainerStyle = css`
  width: 100%;
  height: 100%;
  background-color: rgba(40, 72, 90, 0.8);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 25px;
  font-family: "Noto Serif Japanese", serif;
  letter-spacing: 0.075em;

  @media (max-width: ${spSize}px) {
    font-size: 14px;
  }
`;

const menuItemStyle = css`
  color: white;
  margin-top: 20px;
  text-decoration: none;

  &:hover {
    cursor: pointer;
  }
`;

export default HumburgerMenu;
